<template>
    <div class="flex flex-col h-full items-center justify-center lg:px-0 lg:py-0 px-4 py-10">
        <h4 class="text-center m-y-md md:w-1/2 w-full">{{ $t('awaiting_acceptance.heading') }}</h4>

        <p class="md:w-2/3 pb-6 text-center w-full" v-html="$t('awaiting_acceptance.action_details', { organization: organization.name, emphasizedOpen: '<span class=&quot;font-semibold&quot;>', emphasizedClose: '</span>' })"></p>

        <div class="md:w-1/4 pb-10 w-1/2">
            <svg-loading></svg-loading>
        </div>

        <p class="pt-12 text-center">
            {{ $t('awaiting_acceptance.logout_line') }}
            <a @click="logout" href="javascript:;">
                {{ $t('auth.logout') }}
            </a>
        </p>
    </div>
</template>

<script>
import SvgLoading from '../svg/loading.vue';

export default {
    components: {
        'svg-loading': SvgLoading,
    },

    props: {
        organization: Object,
    },

    data() {
        return {
            form: new Form({}),
        };
    },

    methods: {
        logout() {
            Globals.post('/logout', this.form)
                .then(() => window.location.href = '/')
                .catch(() => {});
        },
    },
};
</script>
